import { FC, ReactNode, useEffect } from 'react';
import { Popover } from 'antd';
import Content from '../popover/Content';
interface Props {
  children?: ReactNode;
  open: boolean;
  setIsOpen: (val: boolean) => void;
}
const HamburgerPopover: FC<Props> = ({
  children,
  open,
  setIsOpen
}: Props) => {
  const handleScroll = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <Popover content={<Content setIsOpen={setIsOpen} />} trigger="click" open={open} placement="bottom">
            {children}
        </Popover>;
};
export default HamburgerPopover;